import { render, staticRenderFns } from "./BeneficioView.vue?vue&type=template&id=7e4d7f1e&scoped=true&"
import script from "./BeneficioView.vue?vue&type=script&lang=ts&"
export * from "./BeneficioView.vue?vue&type=script&lang=ts&"
import style0 from "./BeneficioView.vue?vue&type=style&index=0&id=7e4d7f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4d7f1e",
  null
  
)

export default component.exports